import { ResourceTypeEnum } from '@/shared/components/ui/resource-icon/resource-icon.types';
import { TPolicy } from '@/shared/features/rbac/components/policies/policies.types';

export const POLICIES: TPolicy = {
  [ResourceTypeEnum.Ideaas]: ['ideaas:*', 'ideaas:readSessionRecording'],
  [ResourceTypeEnum.Project]: [
    'project:*',
    'project:createProject',
    'project:createVersion',
    'project:readProject',
    'project:listVersions',
    'project:downloadVersion',
    'project:updateProject',
    'project:updateVersion',
    'project:deleteProject',
    'project:deleteVersion',
    'project:linkProject',
    'project:linkDevice',
    'project:unlinkProject',
    'project:unlinkDevice',
    'project:lockProject',
    'project:unlockProject',
    'project:adminUnlockProject',
  ],
  [ResourceTypeEnum.Device]: [
    'device:*',
    'device:createDevice',
    'device:readDevice',
    'device:updateDevice',
    'device:deleteDevice',
    'device:linkDevice',
    'device:unlinkDevice',
    'device:linkGateway',
    'device:unlinkGateway',
    'device:connect',
    'device:deploy',
    'device:backup',
    'device:snapshot',
    'device:setPassword',
    'device:readVariableList',
    'device:writeVariableList',
  ],
  [ResourceTypeEnum.Document]: [
    'document:*',
    'document:createDocument',
    'document:createVersion',
    'document:readDocument',
    'document:listVersions',
    'document:downloadVersion',
    'document:updateDocument',
    'document:updateVersion',
    'document:deleteDocument',
    'document:deleteVersion',
    'document:linkProject',
    'document:linkDevice',
    'document:linkGateway',
    'document:linkLicense',
    'document:linkUser',
    'document:unlinkProject',
    'document:unlinkDevice',
    'document:unlinkGateway',
    'document:unlinkLicense',
    'document:unlinkUser',
  ],
  [ResourceTypeEnum.Gateway]: [
    'gateway:*',
    'gateway:createGateway',
    'gateway:readGateway',
    'gateway:updateGateway',
    'gateway:deleteGateway',
  ],
  [ResourceTypeEnum.Vault]: [
    'vault:*',
    'vault:createVault',
    'vault:createSecret',
    'vault:readVault',
    'vault:listSecrets',
    'vault:linkSecret',
    'vault:updateVault',
    'vault:updateSecret',
    'vault:deleteVault',
    'vault:deleteSecret',
    'vault:unceilSecret',
  ],
  [ResourceTypeEnum.Identity]: [
    'ident:*',
    'ident:createUser',
    'ident:readUser',
    'ident:updateUser',
    'ident:deleteUser',
    'ident:updateProfile',
    'ident:updateTenant',
    'ident:deleteTenant',
    'ident:readUserRole',
    'ident:createUserRole',
    'ident:updateUserRole',
    'ident:deleteUserRole',
    'ident:linkUserRole',
    'ident:unlinkUserRole',
  ],
  [ResourceTypeEnum.Integration]: [
    'integration:*',
    'integration:createIntegration',
    'integration:readIntegration',
    'integration:updateIntegration',
    'integration:deleteIntegration',
    'integration:listRepositories',
    'integration:updateRepository',
  ],
  [ResourceTypeEnum.Group]: [
    'resourceGroup:*',
    'resourceGroup:createResourceGroup',
    'resourceGroup:readResourceGroup',
    'resourceGroup:updateResourceGroup',
    'resourceGroup:deleteResourceGroup',
  ],
  [ResourceTypeEnum.Pipeline]: [
    'pipeline:*',
    'pipeline:createPipeline',
    'pipeline:readPipeline',
    'pipeline:listExecutions',
    'pipeline:triggerExecution',
    'pipeline:updatePipeline',
    'pipeline:deletePipeline',
    'pipeline:deleteExecutions',
  ],
  [ResourceTypeEnum.License]: [
    'license:*',
    'license:createLicense',
    'license:readLicense',
    'license:deleteLicense',
    'license:useLicense',
    'license:adminUnlockLicense',
  ],
  [ResourceTypeEnum.Tag]: [
    'tag:*',
    'tag:createTag',
    'tag:readTag',
    'tag:deleteTag',
    'tag:linkDevice',
    'tag:linkDocument',
    'tag:linkGateway',
    'tag:linkLicense',
    'tag:linkProject',
    'tag:linkUser',
    'tag:linkVault',
    'tag:linkPipeline',
    'tag:unlinkDevice',
    'tag:unlinkDocument',
    'tag:unlinkGateway',
    'tag:unlinkLicense',
    'tag:unlinkProject',
    'tag:unlinkUser',
    'tag:unlinkVault',
    'tag:unlinkPipeline',
  ],
  [ResourceTypeEnum.AuditLog]: ['auditLog:readAuditLog'],
  [ResourceTypeEnum.Vulnerabilities]: [
    'vulnerabilities:*',
    'vulnerabilities:readVulnerabilities',
  ],
  [ResourceTypeEnum.Webhook]: [
    'webhook:*',
    'webhook:createWebhook',
    'webhook:readWebhook',
    'webhook:updateWebhook',
    'webhook:deleteWebhook',
  ],
};
